// This file was automatically generated from appchart.refpanel.maint.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.maint');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maint.reminder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<a class="details-trigger  ', (opt_data.state.excluded) ? 'el8MaintRuleExcluded' : (opt_data.state.pending) ? 'el8MaintRuleUnsatisfied' : 'el8MaintRuleSatisfied', '" data-id="', soy.$$escapeHtml(opt_data.maintRuleId), '" data-name="', soy.$$escapeHtml(opt_data.primaryItemName), '">', soy.$$escapeHtml(opt_data.primaryItemName), '</a>');
  el8.template.appchart.refpanel.maint.reminderExtra(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maint.reminderText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.primaryItemName));
  el8.template.appchart.refpanel.maint.reminderExtra(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maint.reminderExtra = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(' ', (opt_data.state.excluded) ? '<span class="el8MaintRuleExcluded">(Excluded for ' + soy.$$escapeHtml(opt_data.queryYear) + ')</span>' : (! opt_data.state.pending) ? '<span class="el8MaintRuleSatisfied">(Satisfied for ' + soy.$$escapeHtml(opt_data.queryYear) + ')</span>' : '', ' ');
  switch (opt_data.dueClassification) {
    case 'overdue':
      output.append('<span class="el8MaintRuleExcluded">Due date missed for ', soy.$$escapeHtml(opt_data.queryYear), '</span>');
      break;
    case 'interval':
      output.append('<span class="el8Orange el8Medium">Due between ', soy.$$escapeHtml(opt_data.dueDates.dueStartDateStr), ' and ', soy.$$escapeHtml(opt_data.dueDates.dueEndDateStr), '</span>');
      break;
    case 'ending':
      output.append('<span class="el8Orange el8Medium">Due by ', soy.$$escapeHtml(opt_data.dueDates.dueEndDateStr), '</span>');
      break;
    case 'starting':
      output.append('<span class="el8Orange el8Medium">Due starting ', soy.$$escapeHtml(opt_data.dueDates.dueStartDateStr), '</span>');
      break;
    case 'since':
      output.append('<span class="el8Orange el8Medium">Due since ', soy.$$escapeHtml(opt_data.dueDates.dueStartDateStr), '</span>');
      break;
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maint.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var reminderList5411 = opt_data.reminders;
  var reminderListLen5411 = reminderList5411.length;
  for (var reminderIndex5411 = 0; reminderIndex5411 < reminderListLen5411; reminderIndex5411++) {
    var reminderData5411 = reminderList5411[reminderIndex5411];
    output.append('<li class="el8BulletText el8ItemHover am-highlight"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" data-name="', soy.$$escapeHtml(reminderData5411.primaryItemName), '" data-id="', soy.$$escapeHtml(reminderData5411.maintRuleId), '" class="more-actions-trigger el8ActionButton ebs-btn ebs-btn-default">Actions<span class="el8ButtonDropdownIcon"></span></button></div><span class="el8Preserve">');
    el8.template.appchart.refpanel.maint.reminder(reminderData5411, output);
    output.append('</span></li>');
  }
  if (!opt_sb) return output.toString();
};
